import { useMutation } from 'react-fetching-library';
import { useSelector } from 'react-redux';

import selectors from '../../store/selectors';

const postPastoralVisit = accountId => values => ({
  method: 'POST',
  endpoint: `/api/donate/accounts/${accountId}/pastoral-visits`,
  body: values,
});

export const usePostPastoralVisit = () => {
  const accountId = useSelector(selectors.getAccountId);

  return useMutation(postPastoralVisit(accountId));
};
